import Image from 'next/image';
import classNames from 'classnames';
import { FC, useEffect, useMemo, useState } from 'react';
import { BuilderContent } from '@builder.io/react';

import styles from './b2b-footer-top.module.scss';
import BusinessButton from '../../business-button/business-button';
import { Locale, useLocale } from '../../../helpers/LangHelper';
import { COLORS } from '../../business-button/business-button.constants';

interface Props {
    theme?: 'light' | 'dark';
    ctaLink?: string;
    page: any;
}

export const B2BFooterTop: FC<Props> = (props) => {
    const { theme, ctaLink, page } = props;

    const [endCap, setEndCap] = useState<string>();

    useEffect(() => {
        setEndCap('https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fd855b567b9e24d3596a4289a5f643092');
    }, []);

    const title = useMemo(() => {
        return (
            <div className={styles.title}>
                Tap into <span className="footer-asterisk" />
                57M<span className={styles.plus}>+</span>
                <br className={styles.desktopBr} />
                <br className={styles.mobileBr} />
                incremental monthly&nbsp;
                <br className={styles.desktopBr} />
                <br className={styles.mobileBr} />
                active customers&nbsp;
                {/* <br className={styles.desktopBr} />
                today. */}
                <div className={styles.subtitle}>Let shoppers pay in 4 or monthly, driving incremental sales and growth for your business.</div>
                {/* <div className={styles.source}>
                    Source: Internal Afterpay Data
                    <br className={styles.desktopBr} />
                    <br className={styles.mobileBr} />
                    *Monthly active customers of Cash App as of 2024
                </div> */}
            </div>
        );
    }, []);

    return (
        <div className={classNames(styles.container, { [styles['--light']]: theme === 'light' })}>
            <div className={styles.content}>
                <div className={styles.left}>
                    {title}
                    <div className={styles.description}>
                        <ul>
                            <li>
                                <span>•</span>
                                <span>Free sign-up.</span>
                            </li>
                            <li>
                                <span>•</span>
                                <span>Easy integration.</span>
                            </li>
                            <li>
                                <span>•</span>
                                <span>Simple, transparent pricing.</span>
                            </li>
                        </ul>
                    </div>

                    <BuilderContent model="business-hub" content={page}>
                        {(variant) => (
                            <BusinessButton link={variant?.signupLink ?? ctaLink} className={styles.button} buttonText="Get started" target="_blank" color={COLORS.BLACK} />
                        )}
                    </BuilderContent>
                </div>
                <div className={styles.right}>
                    <div className={styles.rightBox}>
                        {endCap ? (
                            <Image
                                src={endCap}
                                alt=""
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                fill={true}
                                loading={'eager'}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                                sizes="(max-width: 638px) 98vw,  (max-width: 998px) 43vw, 46vw"
                                className={styles.image}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};
